import { Component, type ReactNode } from 'react';

type State = { err?: unknown };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = {};

  static getDerivedStateFromError(err: unknown) {
    return { err };
  }

  componentDidCatch(err: unknown, info: unknown) {
    // Keep this log for debugging
    console.error('App crashed:', err, info);
  }

  render() {
    if (this.state.err) {
      return (
        <div className="p-6">
          <h1 className="mb-2 text-xl font-semibold text-red-600">
            Something went wrong.
          </h1>
          <pre className="overflow-auto rounded bg-gray-100 p-3 text-sm">
            {String(this.state.err)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
